import { Box, Container, Grid } from "@mui/material";
import VideoBackgroundWide from "../assets/video-background-main-2.webm";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Section from "./Section";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import * as React from "react";

export default function QuoteSection() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();

  React.useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;

      setTimeout(() => {
        const element = document.getElementById(id);
        const navbar = document.getElementById("navbar");

        if (element && navbar) {
          const top =
            element.getBoundingClientRect().top +
            window.scrollY -
            navbar.clientHeight;

          window.scrollTo({ top, behavior: "smooth" });
        }
      }, 100); // small delay ensures DOM is ready
    }
  }, [location]);

  return (
    <Section id="main" videoSrc={VideoBackgroundWide}>
      <Container
        sx={{ height: { xs: "42vh", sm: "100vh" }, overflow: "hidden", px: 0 }}
      >
        <Grid
          container
          direction="row"
          alignItems="center"
          sx={{ height: "100%", py: 6 }}
        >
          <Box sx={{ width: "100%" }}>
            <Toolbar />
            <Typography
              variant="h3"
              sx={{
                textAlign: "center",
                fontSize: { xs: "2rem", sm: "2rem" },
                fontWeight: 900,
                color: "#f5c33d",
              }}
            >
              «Час — твій союзник <br />і ворог одночасно»
            </Typography>
            <Typography
              variant="h3"
              sx={{
                textAlign: "right",
                mt: 1,
                fontSize: { xs: "1rem", sm: "1.5rem" },
                color: "#f5c33d",
                mr: 4,
              }}
            >
              Стівен Р. Кові
            </Typography>
          </Box>
        </Grid>
      </Container>
    </Section>
  );
}
